import React from 'react';

import type { Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

export enum PARAMS_FROM_VERTICAL_LIST_PAGE_QUERY {
  tabType = 'tabType',
  subproduct = 'subproduct',
  organizationId = 'organizationId',

  limit = 'limit',
  skip = 'skip',

  iframeId = 'iframeId',
}

export interface IVerticalListContext {
  organizationId?: string;
  tab: Tab<VITRINS_OFFERS_TYPE>;

  limit: number;
  skip: number;

  iframeId: string;
}

export const DEFAULT_VERTICAL_LIST_PAGE_CONTEXT: IVerticalListContext = {
  tab: null,
  organizationId: null,

  limit: 10,
  skip: 0,

  iframeId: '',
};

export const VerticalListContext = React.createContext<IVerticalListContext>(DEFAULT_VERTICAL_LIST_PAGE_CONTEXT);
